import { reactive, set } from 'vue-demi';
const { useUser, useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('self-selected-stocks');
const { isLogin } = useUser();

export default (stockList) => {
    const selfSelectedMap = reactive({});
    /* 股票图表数据 */
    const getSelectStatus = async (stock) => {
        const { stockId } = stock;
        let res = false;
        const rsp = await request.get('status', { stockId });
        if (rsp.code === 10002) {
            res = false;
        }
        res = rsp?.data?.result ?? false;
        set(selfSelectedMap, stock.stockId, res);
    };

    const setSelectStatus = async (stock, selected) => {
        const { stockId } = stock;
        await request.post(selected ? 'cancelSubscribeStock' : 'subscribeStock', { stockId });
        set(selfSelectedMap, stock.stockId, !selected);
    };

    const initSelectStatus = () => {
        // 未登录或者没有股票列表数据，不请求
        if (!isLogin || !stockList.value || !stockList.value.length) {
            return;
        }
        stockList.value.map(async (stock) => await getSelectStatus(stock));
    };

    return {
        selfSelectedMap,
        initSelectStatus,
        setSelectStatus
    };
};
